// extracted by mini-css-extract-plugin
export var menuIcon = "_la-0";
export var menuIconInline = "_la-1";